import axios, { AxiosInstance } from 'axios';
import { appUrl, storageKey } from '@/utils/conf';
import { each, forEach, get, isNaN, isNil, isObject, keys, set, trim } from 'lodash-es';
import MD5 from 'crypto-js/md5';
import { useStoreApp } from "@/store/app";
import { localStore } from "poppy-util";
import router from "@/router";


// axios instance
// 拦截器可以查看 : https://axios-http.com/zh/docs/interceptors
const instance: AxiosInstance = axios.create({
    baseURL: appUrl,
    timeout: 30000 // 请求超时 30s
});

/**
 * 请求签名
 * @param params
 * @param token
 */
const requestSignV1 = (params: any, token = '') => {
    let debug = true;
    let str = '';
    let paramsKeys = keys(params);
    paramsKeys.sort();
    forEach(paramsKeys, function (key) {
        if (key !== 'image' && key !== 'file') {
            if (isObject(params[key])) {
                str += key + '=' + JSON.stringify(params[key]) + ','
            } else {
                str += key + '=' + params[key] + ','
            }
        }
    });
    str = str.slice(0, -1);
    const longSign = MD5(token + MD5(token).toString() + MD5(str).toString()).toString()

    let signStr = `${longSign.charAt(8)}${longSign.charAt(2)}${longSign.charAt(4)}${longSign.charAt(0)}`
    if (debug) {
        console.log('ori:', token + '|' + MD5(token).toString() + '|' + MD5(str).toString(), 'sign:', longSign);
    }
    return signStr;
};


// 请求方法
const fetch = (options: RequestOptions) => {
    let { method = 'post', params: oriParams = {}, url, headers = {} } = options;
    let token = localStore(storageKey.USER_TOKEN)
    const timestamp = String(Math.round(new Date().getTime() / 1000));
    let params: any;

    let requestUrl = appUrl + options.url;
    console.log(requestUrl)
    if (oriParams instanceof FormData) {
        params = oriParams;
        params.append('timestamp', timestamp.toString())
        params.append('sign', requestSignV1(params, token ? token : ''));
    } else {
        params = {};
        each(oriParams, function (val, key) {
            if (isNil(val)) {
                return;
            }
            if (isNaN(val)) {
                return;
            }
            let sv = val;
            if (typeof val === 'string') {
                sv = trim(val);
            }
            set(params, key, sv);
        })
        set(params, 'timestamp', timestamp);
        set(params, 'sign', requestSignV1(params, token ? token : ''));
    }
    console.info('地址:' + requestUrl, '\n参数:' + '\n', params);
    // stip : 这里使用 data = {...params, token : token || ''}, 则会丢失form表单的数据

    switch (method.toLowerCase()) {
        case 'get':
            set(params, 'token', token ? token : '');
            return instance.get(url, {
                params
            });
        case 'post':
        default:
            instance.defaults.headers.common['Authorization'] = token
                ? `Bearer ${token}`
                : '';
            if (get(headers, 'Content-Type')) {
                instance.defaults.headers.post['Content-Type'] = get(
                    headers,
                    'Content-Type'
                );
            } else {
                instance.defaults.headers.post['Content-Type'] = 'application/json';
            }
            return instance.post(url, params);
        case 'put':
            return instance.put(url, params);
    }
};

export default function request(options: RequestOptions) {
    return fetch(options)
        .then((response) => {
            const { data = {}, status, message } = response.data;
            console.info('地址:' + "/" + appUrl + options.url, '\n结果:', response.data);
            if (status === 0) {
                /* 请求成功且 状态码为 0
                 * ---------------------------------------- */
                return Promise.resolve({
                    success: true,
                    message: message,
                    status: status,
                    data: data
                });
            } else {
                return Promise.resolve({
                    success: false,
                    status: status,
                    message: message,
                    data: data
                });
            }
        })
        .catch((error) => {
            const { response } = error;
            let msg;
            if (response && response instanceof Object) {
                const { data, statusText, status: code } = response;
                msg = get(data, 'message') || statusText;
                if (code === 401) {
                    useStoreApp().Logout().then(() => {
                        router.push({
                            name: 'user.login'
                        }).then()
                    })
                    return Promise.resolve({
                        success: false,
                        status: code,
                        message: '无权访问, 请登录后重试',
                        data: {}
                    });
                } else if (code === 404) {
                    msg = '网络找不到了,请检查您的网络连接!';
                } else if (code === 500) {
                    msg = '网络开小差了,请检查您的网络连接!';
                } else {
                    msg = '请求出现异常,请联系客服处理';
                }
                console.error(options.url, code, msg, response, error.toJSON());
                return Promise.resolve({
                    success: false,
                    status: code,
                    message: msg,
                    data: {}
                });
            } else {
                msg = error.message || '未知错误(一般是访问超时)';
                if (error.name === 'Error') {
                    if (error.code === 'ECONNABORTED') {
                        if (get(error, 'config.data') instanceof FormData) {
                            msg = '上传超时，请检查网络或压缩图片上传';
                        } else {
                            msg = '请求超时，请检查网络或重试';
                        }
                    }
                    if (error.message === 'Network Error') {
                        msg = '网络连接异常！';
                    }
                }

                console.error(options.url, 520, msg, error.toJSON());
                return Promise.resolve({
                    success: false,
                    status: 520,
                    message: msg,
                    data: {}
                });
            }
        });
}

